import { useEffect } from 'react';
import { useGolferStore } from '../store/GolferStore';
import { useMetaStore } from '../store/MetaStore';
import { useRoundStore } from '../store/RoundStore';
import ScoreEntryView from '../views/ScoreEntryView'; // Adjust the path based on your file structure

const ScoreEntryController = () => {
  const groupRounds = useGolferStore((state) => state.groupRounds)
  const setGroupRounds = useGolferStore((state) => state.setGroupRounds)
  const holeNum = useRoundStore((state) => state.holeNum)
  const setPageTitle = useMetaStore((state) => state.setPageTitle)
  
  useEffect(() => {
    setPageTitle('Score Entry')
  }, [setPageTitle])

  const updateScore = (roundId, newScore) => {
    let tmpArray = groupRounds

    if (newScore > -1) {
      tmpArray.map((el, i) => {
        if (el.roundId === roundId) {
          tmpArray[i].holeScores[holeNum - 1].holeScore = newScore
        }
        return tmpArray
      })

      setGroupRounds([...tmpArray])
    }
  }

  const disableNextButton = () => {
    for (const round of groupRounds) {
      if (round.holeScores[holeNum - 1].holeScore <= 0) {
        return true
      }
    }
    return false
  }

  return (
    <div>
      <ScoreEntryView updateScore={updateScore} disableNextButton={disableNextButton} />
    </div>
  )
}

export default ScoreEntryController
